import { useEffect, useState } from 'react';

import { fetchCountries } from 'utils/fetchers';

export function useCountries(deps = []) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetchCountries().then((data) => setCountries(data));
  }, deps);

  return countries;
}
